<template>
  <svg viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.93099 4.26246C6.0795 3.22225 7.08938 1.11348 9.9408 1C11.0299 1 13.3863 1.65249 14.0991 4.26246"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
    />
    <path
      d="M2.6637 11.2117C2.6637 9.08401 2.81219 5.9634 6.525 3.97744C7.66359 3.31549 10.7724 2.44551 14.0991 4.26113C15.9802 5.53779 19 9.7365 16.0298 16.3182"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
    />
    <path
      d="M17.2178 10.6455C17.7623 10.6455 18.8514 10.9576 18.8514 12.2058C18.9504 13.0569 18.6732 14.6739 16.7722 14.3335"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
    />
    <path
      d="M2.66372 10.6455C2.02017 10.6455 0.792479 11.071 1.0301 12.7732C1.0796 13.3879 1.56474 14.5605 3.10925 14.3335"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
    />
    <path
      d="M2.66373 11.4959C4.59438 11.0703 9.10913 9.7086 11.7229 7.66602"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
    />
    <path
      d="M10.5349 8.51758C11.5744 9.65235 14.3664 11.78 17.2179 11.2127"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
    />
    <path
      d="M12.1685 12.6299C12.515 12.9609 13.4457 13.4242 14.3961 12.6299"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
    />
    <path
      d="M5.33691 12.6299C5.78245 12.9609 6.88143 13.4242 7.7131 12.6299"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
    />
    <path
      d="M2.66357 11.0703C2.66357 14.4746 3.70319 18.8718 9.94067 20.574C10.3367 20.5267 11.2178 20.3187 12.1683 19.8648"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
    />
    <path
      d="M17.5148 19.5818L15.1386 17.4541L14.2475 15.4683C14.099 15.2319 13.881 14.6433 13.3564 14.7591C12.7129 14.9009 11.4258 15.6102 10.6832 17.1705C10.5347 17.4542 10.5347 17.7379 11.4258 18.0216L12.4654 18.4471L13.505 18.8727L15.4356 20.7167"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
    />
    <path
      d="M13.5051 18.8726L15.1387 17.4541"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
    />
    <ellipse
      cx="12.9889"
      cy="6.7002"
      rx="0.523496"
      ry="0.5"
      fill="currentColor"
    />
  </svg>
</template>
